import React from 'react';
import { DailyCheckups } from '../components';

export default () => {
    return (
        <DailyCheckups.Home />
    )
}